import React from 'react';
import { formatInt } from '../utils/format';
import { LIST_CAP } from '../hooks/useCappedPages';
interface PagerProps {
  page: number;
  pages: number;
  setPage: (p: number) => void;
  total: number;
  isCapped: boolean;
}
export function Pager({
  page,
  pages,
  setPage,
  total,
  isCapped
}: PagerProps) {
  return <div className="mt-4 flex flex-wrap items-center justify-between gap-3" data-id="element-653" data-mp="3p8kl06asxpoj">
      <p className="font-mono text-[12px] text-muted" data-id="element-654" data-mp="3bhnx2srtlwnt">{isCapped ? `Showing top ${formatInt(LIST_CAP)} of ${formatInt(total)}` : `${formatInt(total)} entries`}</p>
      {pages > 1 && <div className="flex items-center gap-2" data-id="element-655" data-mp="31k9v1y6n9af1">
          <button type="button" disabled={page === 0} onClick={() => setPage(page - 1)} className="rounded-md border border-line px-3 py-1.5 text-sm text-ink disabled:opacity-40" data-id="element-656" data-mp="31lkxnuocsc4k">
            Previous
          </button>
          <span className="font-mono text-[12px] text-muted" data-id="element-657" data-mp="2slfz8a150o2j">
            {page + 1} / {pages}
          </span>
          <button type="button" disabled={page >= pages - 1} onClick={() => setPage(page + 1)} className="rounded-md border border-line px-3 py-1.5 text-sm text-ink disabled:opacity-40" data-id="element-658" data-mp="1ktvq2v5gh4tb">
            Next
          </button>
        </div>}
    </div>;
}